export default __webpack_public_path__ + "static/media/furiousresurgence.04801401.png";